"use strict";
import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject} from '@angular/core';
import {DynamicModalLoaderService} from "@ispm/layout/services/dynamic-modal-loader.service";
import {CurationActionCreatorService} from "../../../services/curation-action-creator.service";
import { FormHandlerService } from '@ispm/dynamic-form/services/form-handler.service';
import {WorkflowBarActionsCreatorService} from "@ispm/shared/components/workflow-bar/services/workflow-bar-actions-creator.service";
import {CurationEditorAbstract} from "../curation-editor-abstract";
import { PdfService } from '@ispm/dashboard/test/services/pdf.service';
import { CurationSettings } from '../../curation-dashboard/curation-setting';
import { CurationUtils } from '../../../utils/curation-utils';
import { PanelsService } from "@ispm/layout/services/panels.service";
import { CoreActionCreatorService } from "@ispm/core/services/core-action-creator.service";
import {TranslateService} from "@ngx-translate/core";
import { UserActionCreatorService } from '@ispm/user/services/user-action-creator.service';
import { DiagnosticOrderService } from '@ispm/dashboard/test/services/diagnostic-order.service';
import { ActivityService } from '@ispm/user/services/activity.service';
import { AuthenticationService } from '@ispm/user/services/authentication.service';
import {WorkflowConfigService} from "@ispm/workflow/services/workflow-config.service";
import { NotificationMessageService } from '@ispm/core/components/customise-notification/notifications-message.service';
import { NotesService } from '@ispm/user/services/notes.service';
import {HttpInterceptorService} from "@ispm/core/services/http-interceptor.service";
import {ActivatedRoute, Router} from '@angular/router';
import {RouterManagerService} from "@ispm/core/services/router-manager.service";

@Component({
  selector: 'gen-curation-editor-treatmentprotocol',
  templateUrl: './curation-editor-treatmentprotocol.component.html',
  styleUrls: ['./curation-editor-treatmentprotocol.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})

export class CurationEditorTreatmentProtocolComponent extends CurationEditorAbstract {
  public formName: string;

  constructor(authService: AuthenticationService,
              formHandler: FormHandlerService,
              public notificationMessageService: NotificationMessageService,
              workflowBarActionsCreatorService: WorkflowBarActionsCreatorService,
              modalLoader: DynamicModalLoaderService,
              activatedRoute: ActivatedRoute,
              panelService: PanelsService,
              curationActionCreatorService: CurationActionCreatorService,
              translateService: TranslateService,
              protected diagnosticOrderService : DiagnosticOrderService,
              pdfService: PdfService,
              notes: NotesService,
              coreAC: CoreActionCreatorService,
              detector: ChangeDetectorRef,
              public userActionCreatorService: UserActionCreatorService,
              public activityService: ActivityService,
              workflowConfigService: WorkflowConfigService,
              _http: HttpInterceptorService,
              router: Router,
              routerManagerService: RouterManagerService) {
    super(authService, formHandler, notificationMessageService, workflowBarActionsCreatorService, modalLoader,
      activatedRoute, panelService, notes, coreAC, curationActionCreatorService, translateService,
      diagnosticOrderService, userActionCreatorService, activityService, _http, router, pdfService, detector, workflowConfigService, routerManagerService);
  }

  setInitParams() {
    this.formName = this.conf['ui']['forms']['editorForms']['details'].name;
    this.curationActionCreatorService.getState(['definitions'])
      .take(1)
      .subscribe((data => {
        this.confMap = Array.from(data.values()).filter(data => data['type'] === this.curationType || data['type'] === CurationSettings.CURATION_KB)
      }));
  }

    public getCurationKey(): string {
    return this.curationItem.curationData['content']['treatmentPlan']['display'];
  }

  prepareDataToSave(status: string) : Promise<boolean> {
    let confRoot = this.confMap.filter(data => data['type'] === CurationSettings.CURATION_KB)[0];
    CurationUtils.updateRelatedEntities(confRoot, this.curationItem.curationData);
    return Promise.resolve(true);
  }

  updateForm(form) {
    if (form) {
      for (let prop in form) {
        this.curationItem.curationData['content'][prop] = form[prop];
      }
      this.curationKey = this.getCurationKey();
    }
  }

  validationEvent(valid) {
    this.isValid = valid;
  }

  postUpdateCurationItem(){
    this.updateForm(this.curationItem.curationData["content"]);
  }

  postGetCurationItem(){
    this.isDataLoaded = true;
  }

    //Returns array with relaten entity (treatment plan) curationItemId
    public getCurrentRelatedEntitiesIds() : Array<string> {
      let itemsArray = [];
      if (this.curationItem['curationData']['content']['treatmentPlan']){
        itemsArray.push(this.curationItem['curationData']['content']['treatmentPlan']['code']);
      }
      return itemsArray;
    }
}
